import React from 'react';
import ProgressTrendChart from '../../../pages/user-profile-dashboard/components/ProgressTrendChart';

const DestimeTrendCard = ({
  destimeTrendMode,
  setDestimeTrendMode,
  destimeTrendYear,
  setDestimeTrendYear,
  destimeAvailableYears,
  destimeWeeklyTabs,
  destimeTrendWeekIndex,
  setDestimeTrendWeekIndex,
  destimeMonthlyTrendData,
  destimeWeeklyTrendData,
}) => {
  return (
    <div className="lg:col-span-2 bg-card rounded-lg shadow-gaming-md p-4 md:p-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-4 md:mb-6">
        <div className="text-lg md:text-xl font-heading font-semibold text-foreground">인증 사용 추이</div>
        <div className="flex items-center gap-2 flex-wrap">
          <button
            type="button"
            onClick={() => setDestimeTrendMode('monthly')}
            className={`px-3 py-2 rounded-md text-sm font-medium transition-gaming ${
              destimeTrendMode === 'monthly'
                ? 'bg-primary text-primary-foreground shadow-gaming-sm'
                : 'bg-muted/40 text-muted-foreground hover:bg-muted hover:text-foreground'
            }`}
          >
            월별
          </button>
          <button
            type="button"
            onClick={() => setDestimeTrendMode('weekly')}
            className={`px-3 py-2 rounded-md text-sm font-medium transition-gaming ${
              destimeTrendMode === 'weekly'
                ? 'bg-primary text-primary-foreground shadow-gaming-sm'
                : 'bg-muted/40 text-muted-foreground hover:bg-muted hover:text-foreground'
            }`}
          >
            주별
          </button>
          {destimeTrendMode === 'monthly' ? (
            <select
              value={destimeTrendYear}
              onChange={(e) => setDestimeTrendYear(Number(e.target.value))}
              className="ml-2 px-3 py-2 rounded-md bg-muted/40 border border-border text-sm text-foreground"
              aria-label="인증 사용 추이 년도 선택"
            >
              {(destimeAvailableYears || []).map((y) => (
                <option key={y} value={y}>
                  {y}년
                </option>
              ))}
            </select>
          ) : null}
        </div>
      </div>

      {destimeTrendMode === 'weekly' ? (
        <div className="mb-4 overflow-x-auto">
          <div className="flex items-center gap-2 min-w-max">
            {(destimeWeeklyTabs?.tabs || []).map((w) => (
              <button
                key={w}
                type="button"
                onClick={() => setDestimeTrendWeekIndex(w)}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-gaming ${
                  destimeTrendWeekIndex === w
                    ? 'bg-primary text-primary-foreground shadow-gaming-sm'
                    : 'bg-muted/40 text-muted-foreground hover:bg-muted hover:text-foreground'
                }`}
              >
                {w}주차
              </button>
            ))}
          </div>
        </div>
      ) : null}

      {destimeTrendMode === 'monthly' ? (
        <ProgressTrendChart
          data={destimeMonthlyTrendData}
          embedded
          xKey="month"
          lineKey="minutes"
          lineName="인증 사용 시간"
        />
      ) : (
        <ProgressTrendChart
          data={destimeWeeklyTrendData}
          embedded
          xKey="day"
          lineKey="minutes"
          lineName="인증 사용 시간"
        />
      )}
    </div>
  );
};

export default DestimeTrendCard;
